const signupRedirect = () => {
    window.location.replace('https://www.idrive.com/idrive/signup');
    return null;
};

export default signupRedirect;